import { HeaderStyled } from "./Header.styled";
import "./styles.css";
import "antd/dist/antd.css";
import UserIcon from "../../images/cashbach/Vector-user.svg";
import downIcon from "../../images/cashbach/arrow-down-s-line1.svg";
import dividerline from "../../images/cashbach/divider-line.svg";
import { useState, useEffect } from "react";
import { Tab, Nav } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import Restuarantes from "../Restuarantes/Restuarantes";
import HeaderLogo from "../../images/cashbach/Unibank.png";

const Header = (props) => {
  const { tab } = useParams();
  const [activeTab, setActiveTab] = useState("");
  const history = useHistory();

  const onSelectTab = (tab) => {
    setActiveTab(tab);
    history.push(`/${tab}`);
  };

  const showtabs = window.location.pathname === "/myearnings" ? false : true;
  return (
    <>
      <HeaderStyled>
        <div className="headerSection">
          {showtabs && (
            <>
              <div className="allItemsSection">
                <div className="row-item-secion">
                  <Tab.Container activeKey={activeTab} onSelect={onSelectTab}>
                    <Nav className="tabs-section">
                    <div className="tabs-section-inside-div">
                        <Nav.Link eventKey={"Home"}>Inicio</Nav.Link>
                        <img src={dividerline} alt="UserIcon" />
                        <Nav.Link eventKey={"Restuarantes"}>Restaurantes</Nav.Link>
                        <img src={dividerline} alt="UserIcon" />
                        <Nav.Link eventKey={"Ropa"}>Tecnología</Nav.Link>
                        <img src={dividerline} alt="UserIcon" />
                        <Nav.Link eventKey={"Salón"}>Salud y Belleza</Nav.Link>
                        <img src={dividerline} alt="UserIcon" />
                        <Nav.Link eventKey={"Lentes"}>Ropa y Calzado</Nav.Link>
                        <img src={dividerline} alt="UserIcon" />
                        <Nav.Link eventKey={"Servizos"}>Educación</Nav.Link>
                        <img src={dividerline} alt="UserIcon" />
                        <Nav.Link eventKey={"Monederos"}>Hospitalidad</Nav.Link>
                        <img src={dividerline} alt="UserIcon" />
                        <Nav.Link eventKey={"Servicios"}>Recreación y Hogar</Nav.Link>
                      </div>
                    </Nav>
                  </Tab.Container>
                </div>
              </div>
              <hr />
            </>
          )}
        </div>
      </HeaderStyled>
    </>
  );
};

export default Header;
